import type { ThemeColors } from '../../../../tokens/colors/types';
import { border } from './border';
import { divider } from './divider';
import { blue, green, neutral, orange, pale, purple, red } from './palette';
import { deals, retail } from './product';
import { critical, info, positive, shout, warning } from './semantic';
import { typography } from './typography';

const primary: ThemeColors['primary'] = {
  '10': '#F7FCF5',
  '20': '#F0FAEB',
  '30': '#F7FBEB',
  '50': '#A5CD38',
  '70': '#7CA82B',
  '80': '#123300',
  '90': '#123300',
};

const secondary: ThemeColors['secondary'] = {
  '20': '#6CAE00',
  '30': '#6CAE00',
  '50': '#6CAE00',
  '70': '#6CAE00',
  '90': '#6CAE00',
};

const baseColors: ThemeColors = {
  blue,
  green,
  red,
  orange,
  primary,
  secondary,
  purple,
  neutral,
  pale,
  info,
  warning,
  critical,
  positive,
  deals,
  retail,
  shout,
  border,
  divider,
  typography,
};

export default baseColors;
